import Modal from "common/components/Modal/Modal"
import "./style.scss"

const ImportDownloadModal = ({
  onHide,
  visible,
  title,
  options,
  subtitle,
}: $TSMigrationFixMe) => {
  const handleClick = (callback: $TSMigrationFixMe) => {
    callback()
    onHide()
  }
  return (
    <Modal
      onHide={onHide}
      visible={visible}
      header={title}
      className='modal-importacion'
      size='smallM'
    >
      <div>
        <p>{subtitle}</p>
        <div className='m-0 modal-element_container'>
          {options.map((option: $TSMigrationFixMe) => {
            return (
              <div
                className='mt-4 modal-element'
                key={option.id}
                onClick={() => handleClick(option.callback)}
              >
                <img
                  src={option.icon}
                  alt='document-icon'
                />
                <span className='m-1'>{option.label}</span>
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}

export default ImportDownloadModal
